import { render } from "./Cursor.vue?vue&type=template&id=bad65d3a"
import script from "./Cursor.vue?vue&type=script&setup=true&lang=js"
export * from "./Cursor.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/common/sideBars/design/Cursor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bad65d3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bad65d3a', __exports__)) {
    api.reload('bad65d3a', __exports__)
  }
  
  module.hot.accept("./Cursor.vue?vue&type=template&id=bad65d3a", () => {
    api.rerender('bad65d3a', render)
  })

}


export default __exports__